import React, { useState, useEffect, useRef } from "react";
import PhpApiService, { Users } from "../../phpApiService";

const UserList: React.FC = () => {
  const [data, setData] = useState<Users[]>([]);
  const [newItem, setNewItem] = useState<string>("");
  const phpApiService = useRef(new PhpApiService());

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedData = await phpApiService.current.getData();
        setData(fetchedData);
      } catch (error) {
        console.error("There was an error fetching the data!", error);
      }
    };

    fetchData();
  }, []);

  const addItem = async () => {
    try {
      const newItemWithId = await phpApiService.current.addNewData(newItem);
      setData([...data, newItemWithId]);
      setNewItem("");
    } catch (error) {
      console.error("There was an error adding the item!", error);
    }
  };

  return (
    <div>
      <h1>Data List</h1>
      <ul>
        {data.map((item) => {
          console.log(item);
          return (
            <li key={item.id}>
              {item.name} {item.email}
            </li>
          );
        })}
      </ul>

      <input
        type="text"
        value={newItem}
        onChange={(e) => setNewItem(e.target.value)}
      />
      <button onClick={addItem}>Add Item</button>
    </div>
  );
};

export default UserList;
